import { gql } from '@apollo/client';

export const createVerificationProfileMutation = gql`
  mutation CreateVerificationProfile($espAccountId: Long!, $profileId: String!) {
    createVerificationProfile(espAccountId: $espAccountId, profileId: $profileId) {
      id
    }
  }
`;

export const deleteVerificationProfileMutation = gql`
  mutation DeleteVerificationProfile($id: Long!) {
    deleteVerificationProfile(id: $id)
  }
`;

export const syncWhatsAppAndFetchEspAccountMutation = gql`
  mutation SyncWhatsAppAndFetchEspAccount($businessAccountId: String!) {
    syncWhatsAppAndFetchEspAccount(businessAccountId: $businessAccountId) {
      ... on ESPAccount {
        id
      }
      ... on ESPAccountMutationError {
        message
      }
    }
  }
`;
